// removed by extract-text-webpack-plugin
module.exports = {"actionsCell":"MN9t8eDNt0rwW0aUaowek"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectStatsViewerRow/ProjectStatsViewerRow.scss
// module id = 1371
// module chunks = 1